export const ROUTES = {
    home: '/',
    borrowerStart: '/borrower-start',
    investorStart: '/investor-start',
    investmentDetails: '/investment-details/:id',
    invest: '/invest/:id',
    solvencyDeclaration: '/solvency-declaration',
    solvencyDeclarationWebview: '/solvency-declaration/webview',
    loanApplication: '/loan-application',
    loanDetails: '/loan-application/:id',
    about: '/about',
    login: '/dev/login',
    demoCalculator: '/demo-calculator',
};
